var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"wrapper"}},[_c('NavBar'),_c('SideBar'),_c('div',{attrs:{"id":"page-wrapper"}},[_c('router-view')],1),_c('RightSideBar'),_c('footer',{staticClass:"footer text-center inspect"},[_vm._v(" "+_vm._s(_vm.yearcopy)+" © SMERP. All Rights Reserved. ")]),_c('FileManager'),_c('ImageFilter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }